import { numberFormat } from '@libs/core';
import { AssetsSvgMap, TCalculatorBonus } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { EWidgetVersion } from '../../../types/enums';
import { VisualView } from '../../Image/VisualView';
import { FeeBlockV1 } from './FeeBlockV1';

type TFeePanelProps = {
    bonus: TCalculatorBonus;
    label: string;
    onClick?: MouseEventHandler;
    parentStyleNames?: string[];
};

const BonusV1 = React.memo(({ bonus, label, onClick, parentStyleNames }: TFeePanelProps) => {
    const prefix = (() => {
        switch (bonus.direction) {
            case 'PLUS':
                return '+';
            case 'MINUS':
                return '-';
            default:
                return '';
        }
    })();

    return (
        <FeeBlockV1
            icon={
                bonus.iconName ? (
                    <VisualView
                        version={EWidgetVersion.V1}
                        as="button"
                        uid="calculator_info_icon_bonus"
                        iconName={bonus.iconName}
                        defaultIconName={AssetsSvgMap.ic_x}
                        iconWidth={16}
                        iconHeight={16}
                        iconColor="var(--grey_72_lc)"
                        hovered={{ backgroundColor: 'var(--grey_16_lc)' }}
                        parentStyleNames={parentStyleNames}
                        styleName="calculatorInfoIcon"
                        handleClick={onClick}
                        margin={{ left: 6 }}
                    />
                ) : null
            }
            title={label ?? ''}
            text={`${prefix}${numberFormat(bonus.sum) as string} ${bonus.currency?.toUpperCase()}`}
            textColor="var(--purple_100)"
            parentStyleNames={parentStyleNames}
        />
    );
});
export { BonusV1 };
